<template>
  <div class="edit">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <b>
          {{ isCreate ? '新建媒体(Create New Media)' : '编辑媒体(Edit New Media)' }}
        </b>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div v-if="detail.autoCreate === 1" class="auto-create-tip">
      <p>若未传递Tagid时，ADX广告位仅支持使用兜底广告位。请您检查是否已传递Tagid。</p>
      <p>If no Tagid is provided, the ADX ad slot will only use a fallback ad slot. Please check if a Tagid has been passed.</p>
    </div>
    <el-form class="detail" :model="detail" :rules="rule" label-width="250px" ref="form">
      <el-form-item style="margin-top: 20px" v-for="item in formConfig"  :key="item.prop" :class="item.prop === 'description' ? 'desc' : ''" :label="item.label" :prop="item.prop">
        <el-radio-group v-if="item.prop === 'status'" v-model="detail[item.prop]" :disabled="detail[item.prop] === -1">
          <el-radio v-for="it in computedStatus" :label="it.id" :key="it.id">{{ it.name }}</el-radio>
        </el-radio-group>
        <el-radio-group v-else-if="item.prop === 'platformId'" v-model="detail[item.prop]" :disabled="!isCreate">
          <el-radio v-for="it in platformList" :label="it.id" :key="it.id">{{ it.name }}</el-radio>
        </el-radio-group>
        <el-radio-group v-else-if="item.prop === 'accessType'" v-model="detail[item.prop]" :disabled="!isCreate">
          <el-radio v-for="it in accessMethodList" :label="it.id" :key="it.id">{{ it.name }}</el-radio>
        </el-radio-group>
        <el-select v-else-if="item.prop === 'industryId'" v-model="detail[item.prop]" placeholder="请选择所属行业/Select Industry" filterable clearable>
          <el-option v-for="option in industryList" :key="option.id" :value="option.id" :label="option.displayName"/>
        </el-select>
        <el-input v-else-if="item.prop === 'downloadUrl'" :type="item.type" :rows="5" placeholder="请输入安装包地址或App Store link/Input installation address or App Store link" v-model="detail[item.prop]" :maxlength="item.maxLength || null" clearable></el-input>
        <el-input v-else :type="item.type" :rows="5" :disabled="(['id'].includes(item.prop))" :placeholder="placeholderText(item.label)" v-model="detail[item.prop]" :maxlength="item.maxLength || null" clearable></el-input>
        <div class="item-tip" v-if="item.tip" v-html="item.tip"/>
      </el-form-item>
      <el-form-item class="bottom-button">
        <el-button @click="$router.push({name: 'media'})">取消(Cancel)</el-button>
        <el-button type="primary" @click="save">确认(Confirm)</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {sspApi} from '@/api';
import {placeholderText} from '@/tools/common-utils';
import {PlatformEnum, StatusEnum, AccessMethodEnum} from '@/enums/enums';

export default {
  data: function () {
    return {
      platformList: Object.values(PlatformEnum),
      statusList: Object.values(StatusEnum),
      accessMethodList: Object.values(AccessMethodEnum),
      industryList: [],
      userList: [],
      detail: {
        id: undefined,
        name: '',
        status: 1,
        platformId: 33,
        accessType: 2,
        industryId: undefined,
        bundle: '',
        downloadUrl: '',
        description: ''
      },
      config: [
        {prop: 'id', label: '媒体ID(Media ID)', type: 'text'},
        {prop: 'name', label: '媒体名称(Media Name)', type: 'text', maxLength: 100},
        {prop: 'status', label: '状态(Status) '},
        {prop: 'platformId', label: '操作系统(OS)'},
        {prop: 'accessType', label: '接入方式(Access Method)'},
        {prop: 'industryId', label: '所属行业(Industry)'},
        {prop: 'bundle', label: '程序包名(Package Name)', type: 'text', maxLength: 255},
        {prop: 'downloadUrl', label: '安装包地址(Installation Address)', type: 'textarea', maxLength: 500, tip: "注意：Android为Google Play链接，iOS为App Store链接<br/>Attention: For Android, it's the Google Play link. For iOS, it's the App Store link"},
        {prop: 'description', label: '媒体描述(Description)', type: 'textarea', maxLength: 200}
      ],
      rule: {
        name: [
          {required: true, message: '请输入媒体名称/Input Media Name', trigger: 'blur'},
        ],
        industryId: [
          {required: true, message: '请选择所属行业/Select Industry', trigger: 'change'}
        ]
      }
    }
  },
  created: function () {
    sspApi.getMediaConfig({params: {mediaId: this.mediaId}}).then(({industryList, media, userList}) => {
      this.industryList = industryList;
      this.userList = userList;
      if (media) {
        this.detail = {
          ...this.detail,
          ...media
        };
      }
    }).catch(this.$rejectAjaxError());
  },
  methods: {
    placeholderText,
    save: function () {
      this.$element.checkForm(this.$refs.form);
      this.$confirm('确认提交(Confirm and Submit)？', '', {
        confirmButtonText: '确认(Confirm)',
        cancelButtonText: '取消(Cancel)',
        type: 'info'
      }).then(() => {
        sspApi.editMedia({data: this.detail}).then(() => {
          this.$router.push({name: "media"});
        }).catch(this.$rejectAjaxError());
      }).catch(() => {});
    }
  },
  computed: {
    mediaId: function () {
      return this.$route.params.mediaId
    },
    isCreate: function () {
      return this.mediaId === undefined
    },
    formConfig() {
      return this.config.filter(item => {
        if (this.detail.platformId === PlatformEnum.IOS.id && ['bundle'].includes(item.prop)) {
          return false
        }
        return !(this.isCreate && ['id'].includes(item.prop));
      });
    },
    computedStatus() {
      return this.detail.status === -1 ? this.statusList : this.statusList.filter(item => item.id !== -1)
    }
  },
  watch: {
    'detail.platformId'(newVal) {
      if (newVal === PlatformEnum.IOS.id) {
        this.detail.bundle = ''
      }
    }
  }
}
</script>
<style scoped>
.detail {
  font-size: 10px;
  padding-left: 20px;
}

.detail >>> .el-col {
  height: 30px;
  width: 40%;
}

.detail >>> .el-input, .detail >>> .el-textarea {
  width: 350px;
}

.desc {
  height: 110px;
}

.desc >>> .el-input__inner {
  height: 200px;
}

.detail >>> .el-form-item__label {
  width: 100px
}

.bottom-button {
  width: 600px;
  text-align: right;
}

.item-tip {
  color: #909399;
}

.auto-create-tip {
  margin-top: 20px;
  font-size: 14px;
  background-color: cornsilk;
  padding: 10px;
  width: 780px;
  border-radius: 3px;
}
</style>
